import { Routes } from '@angular/router';
import { GuaranteeView } from '../guarantee-view/guarantee-view';
import { IntegratedBankGuaranteeView } from '../integrated-bank-guarantee-view/integrated-bank-guarantee-view';

export const BANK_GUARANTEE_SUBMISSIONS_ROUTES: Routes = [
  {
    path: '',
    redirectTo: 'integrated-bank-guarantee',
    pathMatch: 'full',
  },
  {
    path: 'integrated-bank-guarantee/view/:uuid',
    component: IntegratedBankGuaranteeView,
  },
  {
    path: 'cash-bank-guarantee/view/:uuid',
    component: GuaranteeView,
    data: { type: 'cash' },
  },
  {
    path: 'manual-bank-guarantee/view/:uuid',
    component: GuaranteeView,
    data: { type: 'manual' },
  },
  {
    path: 'integrated-bank-guarantee',
    loadComponent: () =>
      import('../integrated-bank-guarantee-submission/integrated-bank-guarantee-submission').then(
        (c) => c.IntegratedBankGuaranteeSubmission,
      ),
  },
  {
    path: 'cash-bank-guarantee',
    loadComponent: () =>
      import('../cash-bank-guarantee-submission/cash-bank-guarantee-submission').then(
        (c) => c.CashBankGuaranteeSubmission,
      ),
  },
  {
    path: 'manual-bank-guarantee',
    loadComponent: () =>
      import('../manual-bank-guarantee-submission/manual-bank-guarantee-submission').then(
        (c) => c.ManualBankGuaranteeSubmission,
      ),
  },
];
